import compareVersions from 'compare-versions';
import React from 'react';
import licensesJson from '../license-list.json';

const licenseKeys = Object.keys(licensesJson);
const newLicenses = {};
const versions = {};
licenseKeys.forEach((key) => {
    const license = licensesJson[key];

    if (!license.private) {
        const tmp = key.match(/(.+)@(.+)$/);
        if (!tmp) {
            return;
        }
        const name = tmp[1];
        const version = tmp[2];
        if (!versions.hasOwnProperty(name)) {
            newLicenses[key] = {licenses: license.licenses, repository: license.repository};
            versions[name] = version;
        } else if (compareVersions(versions[name], version) < 1) {
            delete newLicenses[name + '@' + versions[name]];
            newLicenses[key] = {licenses: license.licenses, repository: license.repository};
            versions[name] = version;
        }
    }
});

export const LicensePage = () => {
    return (
        <React.Fragment>
            <div>
            <table border='1'>
                <tr>
                    <th>License Name</th>
                    <th>License document</th>
                </tr>
                <tr>
                    <td>Apache-2.0</td>
                    <td>http://www.apache.org/licenses/LICENSE-2.0</td>
                </tr>
                <tr>
                    <td>Unlicense</td>
                    <td>https://unlicense.org/</td>
                </tr>
                <tr>
                    <td>CC BY 4.0</td>
                    <td>https://creativecommons.org/licenses/by/4.0/legalcode</td>
                </tr>
                <tr>
                    <td>CC0v1.0</td>
                    <td>https://creativecommons.org/licenses/by/1.0/legalcode</td>
                </tr>
                <tr>
                    <td>ISC License</td>
                    <td>https://www.isc.org/licenses/</td>
                </tr>
                <tr>
                    <td>Zlib</td>
                    <td>https://opensource.org/licenses/Zlib</td>
                </tr>
                <tr>
                    <td>WTFPL</td>
                    <td>http://www.wtfpl.net/about/</td>
                </tr>
                <tr>
                    <td>CC BY 3.0 Unported</td>
                    <td>https://creativecommons.org/licenses/by/3.0/legalcode</td>
                </tr>
                <tr>
                    <td>BSD-2-Clause</td>
                    <td>https://opensource.org/licenses/BSD-2-Clause</td>
                </tr>
                <tr>
                    <td>BSD-3-Clause</td>
                    <td>https://opensource.org/licenses/BSD-3-Clause</td>
                </tr>
                <tr>
                    <td>MIT</td>
                    <td>https://opensource.org/licenses/MIT</td>
                </tr>
                <tr>
                    <td>UNKNOWN</td>
                    <td>https://github.com/fitzgen/glob-to-regexp/blob/master/README.md</td>
                </tr>
                <tr>
                    <td>AFLv2.1</td>
                    <td>https://spdx.org/licenses/AFL-2.1.html</td>
                </tr>
                <tr>
                    <td>MPL-2.0</td>
                    <td>http://www.mozilla.org/MPL/2.0/</td>
                </tr>
            </table>
        </div>
            <pre>{JSON.stringify(newLicenses, null, 4)}</pre>
        </React.Fragment>
    );
};

export default LicensePage;
